import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    question: 'What is SyNeural?',
    answer: 'SyNeural is the company building intelligence in the world. Its work has three complementary parts: the Semantic Knowledge Platform (SKP), which connects and governs concepts, sources, and approved knowledge; the Human Capability Framework, which defines assessment and development through CJI and NCJI, including assessment methods, interpretation rules, and development pathways; and Noetivra, a visual, interactive workspace (in development) that makes these resources accessible through interactive views, assessments, and workflows.'
  }, {
    question: 'What is the difference between CJI and NCJI?',
    answer: 'CJI (Civic Judgment Index) is the foundational assessment framework, focused on defined reasoning and judgment tasks, including manipulation resistance, and on how their results are interpreted. NCJI (Neurocognitive Civic Judgment Index) is the broader developmental framework that connects those findings to lifecycle development, opportunity guidance, institutional readiness, and leadership readiness.'
  }, {
    question: 'Is NCJI just a score?',
    answer: 'No. NCJI is a progression system, not a static score. It is designed to identify capability gaps and immediately pair them with developmental pathways, institutional support, and actionable recommendations to build readiness over time.'
  }, {
    question: 'Who is the framework for?',
    answer: 'The framework is designed for multiple layers of society: educational institutions developing youth capability, employers seeking better execution and leadership, civil society organizations building resilience, and governments modernizing civil service and executive readiness.'
  }, {
    question: 'How does it scale globally?',
    answer: 'The framework is designed for municipal, regional, and national use. It could support localized insight for community development and aggregate analysis for national capability planning. Aggregate patterns are not judgments about individuals, and any large-scale use would require appropriate validation, privacy protections, and oversight.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-241" data-mp="38jet6kez31b2">
      <div className="text-center mb-12" data-id="element-242" data-mp="33mxuwxe276k9">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-243" data-mp="2yn1qwy5d3f4p">
          Frequently Asked Questions
        </h2>
      </div>

      <div className="space-y-4" data-id="element-244" data-mp="2ukydi3z4u0gs">
        {faqs.map((faq, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: index * 0.1
      }} className="border border-line rounded-lg bg-white overflow-hidden" data-id="element-245" data-mp="1n8ervbu82x31" data-mpi={index}>
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none" aria-expanded={openIndex === index} data-id="element-246" data-mp="cfnh1uytdihy">
              <span className="text-lg font-heading font-bold text-ink-dark pr-8" data-id="element-247" data-mp="mca2olyysdl1">
                {faq.question}
              </span>
              <span className="text-navy flex-shrink-0" data-id="element-248" data-mp="vejav56rfuv9">
                {openIndex === index ? <Minus size={20} data-id="element-249" data-mp="vcf6yn8v2vuz" /> : <Plus size={20} data-id="element-250" data-mp="2s7bc1ku9p0y4" />}
              </span>
            </button>

            <AnimatePresence data-id="element-251" data-mp="2s9fr8yxm9mdp">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} data-id="element-252" data-mp="2x6o6orrdrcb9">
                  <div className="px-6 pb-6 text-ink-muted leading-relaxed" data-id="element-253" data-mp="1j3dtqy0pixcn">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}